import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ContactUsLeft from "./ContactUsLeft";
import { t } from "i18next";
import CustomImageComponent from "./CustomImageComponent";
import * as constants from "../constants";
import { useCountryPrefix } from "../routes/useCountryPrefix";
import { useTranslation } from "react-i18next";
import { fetchAPI } from "../helper/fetchAPI";

const ContactUsForm = (props) => {

  const { imgDiv } = props;
  const { i18n } = useTranslation();

  const countryPrefix = useCountryPrefix(); // ✅ now inside Router context
  const isArabic = i18n.language === "ar";
  const language = isArabic ? "ar" : "en";
  const [contactSection, setContactSection] = useState({
    Phone: "",
    Email: "",
    Address: "",
    AddressLink: "",
    WorkingDayFrom: "",
    WorkingDayTo: "",
    WorkingTimeFrom: "",
    WorkingTimeTo: ""
  });


  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {

    let apiUrl = process.env.REACT_APP_API_URL;

    apiUrl = `${apiUrl}${constants.footersection}?language=${language}&region_id=${countryPrefix}`;
    const res = await fetchAPI(apiUrl, "Get");
    if (res?.status === 200) {
      var contactData = res?.data?.footerSections?.contactSection


      setContactSection({
        Phone: contactData && contactData.find(x => x.fieldName === "Phone")?.fieldContent || "",
        Email: contactData && contactData.find(x => x.fieldName === "Email")?.fieldContent || "",
        Address: contactData && contactData.find(x => x.fieldName === "Address")?.fieldContent || "",
        AddressLink: contactData && contactData.find(x => x.fieldName === "AddressLink")?.fieldContent || "",
        WorkingDayFrom: contactData && contactData.find(x => x.fieldName === "WorkingDayFrom")?.fieldContent || "",
        WorkingDayTo: contactData && contactData.find(x => x.fieldName === "WorkingDayTo")?.fieldContent || "",
        WorkingTimeFrom: contactData && contactData.find(x => x.fieldName === "WorkingTimeFrom")?.fieldContent || "",
        WorkingTimeTo: contactData && contactData.find(x => x.fieldName === "WorkingTimeTo")?.fieldContent || ""
      });


      // setContactSection(res?.data?.footerSections?.contactSection)

    }
  }
  return (
    <section className="contact-section">
      <div className="container" data-aos="fade-up" data-aos-duration="1500">
        <h2 className="title text-center">{t("consultation_request")}</h2>
        <h5 className="sub-title text-center">
          {t("consultation_request_detail")}
        </h5>
        <div className="row g-0">
          <div className="col-md-10 mx-auto">
            <div className="row">
              <div className="col-md-12 col-lg-6 p-0">
                <ContactUsLeft heading={false}></ContactUsLeft>
              </div>
              {imgDiv ? (
                <div className="col-md-12 col-lg-6 p-0">
                  <CustomImageComponent
                    src={"/assets/img/contact-img.jpg"}
                    alt={"contact"}
                    className={"contact-img"}
                  />
                </div>
              ) : (
                <div className="col-md-12 col-lg-6 p-md-0">
                  <div className="contact-info">
                    <CustomImageComponent src={"/assets/img/logo.svg"} alt={"Connect Homes"} className={"logo"} />
                    <div className="flex-card">
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/address-icon.svg"}
                            alt={"Address"}
                            className={"img-fluid"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <h3>{t("address")}</h3>
                        <a href={contactSection.AddressLink} target="_blank">
                          {contactSection.Address}</a>

                      </div>
                    </div>
                    <div className="flex-card">
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/phone-icon.svg"}
                            alt={"Phone"}
                            className={"img-fluid"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <h3>{t("contact")}</h3>
                        <p>
                          <a href={`tel:${contactSection.Phone}`}>{contactSection.Phone}</a>
                        </p>
                        <p>
                          <a href={`mailto:${contactSection.Email}`}>
                            {contactSection.Email}
                          </a>
                        </p>
                      </div>
                    </div>

                    <div className="flex-card flex-card-hrs">
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/time-icon.svg"}
                            alt={"Time"}
                            className={"img-fluid"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <h3>{t("working_hours")}</h3>
                        <span>{contactSection.WorkingDayFrom} - {contactSection.WorkingDayTo}</span><br></br>
                        <span>{contactSection.WorkingTimeFrom} - {contactSection.WorkingTimeTo}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsForm;
